import React from "react";
import { BsFacebook } from "react-icons/bs";
import { RiInstagramFill } from "react-icons/ri";
import { AiFillTwitterCircle } from "react-icons/ai";
import "./SocialMedia.css";

export default function Icons() {
  return (
    <div className="social_icons">
      <a href="https://www.facebook.com" target="__blank">
        <div className="icons">
          <BsFacebook className="media_icons" id="facebook_icon" />
        </div>
      </a>
      <a href="https://www.instagram.com" target="__blank">
        {" "}
        <div className="icons">
          <RiInstagramFill className="media_icons" id="instagram_icon" />
        </div>
      </a>
      <a href="https://www.twitter.com" target="__blank">
        <div className="icons">
          <AiFillTwitterCircle className="media_icons" id="twitter_icon" />
        </div>
      </a>
    </div>
  );
}
